<template>
  <div id="login-wrapper" class="bg-blue-fade fadein w-full flex items-center justify-center flex-col">
    <router-link
      ref="props.button.buttonLink"
      to="/"
      class="absolute left-5 top-5 flex justify-center bg-slate-middle cursor-pointer p-3 m-3 rounded-full"
    >
      <img class="-ml-px w-4 h-4 invert" :src="Arrow" />
    </router-link>
    <div class="flex justify-center items-center lg:w-1/3 md:w-1/2 w-5/6">
      <PinPopup v-if="state.pinPopup" @close-popup="closePopup()" />
      <div v-else class="bg-slate-middle p-3 rounded-xl w-full h-full">
        <div class="p-3">
          <h1 class="text-2xl text-slate-white font-bold mb-3">{{ t('login') }}</h1>
          <div v-for="(button, index) in authMethods" :key="index" class="flex text-slate-white lp-bg-gray rounded-xl h-20 cursor-pointer my-1">
            <a class="w-full flex items-center" @click="login(button)">
              <div class="flex justify-center items-center">
                <img :key="index" :src="button.icon" :alt="button.name" class="mx-5 p-1 w-11 h-11" />
                <div class="text-xl">
                  {{ t(button.label) }}
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onBeforeMount, onMounted, reactive } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useI18n } from 'vue-i18n'

  import { authMethods, LoginType } from '@/constants'
  import { DialogMessageType } from '@/common/classes'
  import { AuthType } from '@/common/interfaces'

  import useApiService from '@/composables/api'
  import useDialogStore from '@/composables/dialog'

  import PinPopup from '@/components/popups/PinPopup.vue'
  import Arrow from '@/assets/icons/fontawesome/angle-left-solid.svg'

  const route = useRoute()
  const router = useRouter()
  const apiService = useApiService()
  const dialogStore = useDialogStore()

  const messages = {
    no: {
      anonymous: 'Delta med PIN',
      missingpin: 'Vennligst oppgi en PIN kode før du fortsetter',
      wrongpin: 'Vennligst velg en annen PIN og prøv igjen',
    },
    en: {
      anonymous: 'Join with PIN',
      missingpin: 'Please enter a PIN code before you proceed',
      wrongpin: 'Please choose another PIN and try again',
    },
  }

  const { t } = useI18n({ messages })

  const state = reactive({
    pinPopup: false,
  })

  onBeforeMount(async () => {
    state.pinPopup = !!route.query.link
  })

  function redirectToAuth(authType: AuthType) {
    window.location.href = authType.url
  }

  async function login(authType: AuthType) {
    if (authType.type === LoginType.PIN) state.pinPopup = true
    else redirectToAuth(authType)
  }

  function closePopup() {
    state.pinPopup = false
  }
</script>

<style scoped>
  #login-wrapper {
    height: 100vh;
  }
</style>
